import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  balanceBillingStatus: {
    step: string;
    subStep: 
      {
        id: number;
        subStep: string;
        tip: string;
      }[];
  }[];
  error: boolean;
  loading: boolean;
} = {
  balanceBillingStatus: [],
  error: false,
  loading: false,
};
const fetchBalanceBillingStatus = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BALANCE_BILLING_STATUS_SUCCESS: {
      return updateObject(state, {
        balanceBillingStatus: action.balanceBillingStatus,
        error: false,
        loading: false,
      });
    }
    case actionTypes.FETCH_BALANCE_BILLING_STATUS_STARTED:
      return updateObject(state, {
        error: false,
        loading: true,
      });

    case actionTypes.FETCH_BALANCE_BILLING_STATUS_FAILED:
      return updateObject(state, {
        error: true,
        loading: false,
      });

    default:
      return state;
  }
};

export default fetchBalanceBillingStatus;
